'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const faqItems = [
  { question: 'Which is the trusted Sonar Vadhu Var Suchak Mandal in Mumbai?', answer: 'In Mumbai city, MarathiVadhuVarSuchak.com is the most trusted Sonar Vadhu Var Suchak Mandal.' },
  { question: 'Which is the best Lad Sonar Vadhu Var Mandal in Mumbai?', answer: 'MarathiVadhuVarSuchak.com Marathi matrimony is the trusted app for Lad Sonar Vadhu Var.' },
  { question: 'Which the best Sonar Vadhu Var Suchak Mandal Pune?', answer: 'For Pune-based Sonar Vadhu Var, MarathiVadhuVarSuchak.com Marathi matrimony is the best trusted brand.' },
  { question: 'How to attend the Lad Sonar Vadhu Var Melava in Maharashtra?', answer: 'MarathiVadhuVarSuchak.com Marathi matrimony organizes Vadhu Var Melava every year. Keep visiting site for latest updates.' },
  { question: 'Which is the best Panchal Sonar Vadhu Var Suchak Mandal?', answer: 'If searching Panchal Sonar Vadhu Var Suchak Mandal, then MarathiVadhuVarSuchak.com matrimony is the trusted brand.' },
  { question: 'How to do Sonar Matrimony Login online?', answer: 'First Sonar grooms and brides have to register free through the MarathiVadhuVarSuchak.com mobile app. Then you can register free with login credentials.' },
  { question: 'Which is the best Marathi Sonar Matrimony in Pune?', answer: 'For Pune-based Sonar Samaj Vadhu Var, MarathiVadhuVarSuchak.com Marathi matrimonial mobile app is the trusted brand.' },
  { question: 'Which is the best Ahir Sonar Matrimony in Mumbai?', answer: 'MarathiVadhuVarSuchak.com Marathi matrimony mobile app is the trusted Ahir Sonar Matrimony in Mumbai city.' },
  { question: 'How to search the Marathi Sonar matrimony grooms online?', answer: 'Marathi Sonar brides can search Marathi Sonar grooms online through MarathiVadhuVarSuchak.com Marathi matrimony mobile app.' },
  { question: 'How to do the Sonar Matrimony Search by ID online?', answer: 'Register through the MarathiVadhuVarSuchak.com Marathi matrimony app to search Marathi Sonar grooms and brides by ID.' },
  { question: 'Which is the best Zade Sonar Matrimony in Maharashtra?', answer: 'MarathiVadhuVarSuchak.com Marathi matrimony site is the best Zade Sonar Matrimony in Maharashtra state.' },
  { question: 'How to search the Marathi Daivadnya Brahmin Sonar grooms and brides?', answer: 'To search the Marathi Daivadnya Brahmin Sonar grooms and brides, register free on MarathiVadhuVarSuchak.com Marathi matrimony site.' },
  { question: 'Which is the best Marathi Daivadnya Sonar Matrimony in Mumbai?', answer: 'In Mumbai city, MarathiVadhuVarSuchak.com Marathi matrimony is the best choice for Marathi Daivadnya Sonar Matrimony registration.' },
  { question: 'How to search the Marathi Lad Sonar Matrimony profiles?', answer: 'To search the Marathi Lad Sonar Matrimony profiles, visit MarathiVadhuVarSuchak.com Marathi matrimony portal.' },
  { question: 'How to search the Marathi Sonar Matrimony Brides profile?', answer: "Sonar Samaj grooms can search the Marathi Sonar Samaj bride's verified profiles thorough MarathiVadhuVarSuchak.com Marathi matrimony app." },
  { question: 'Which is the best Marathi Sonar Matrimony Nagpur?', answer: 'For Nagpur-based Marathi Sonar Samaj grooms and brides, MarathiVadhuVarSuchak.com Marathi matrimony app is trusted brand.' },
  { question: 'Which are most trusted Marathi Sonar Matrimony Sites in Maharashtra?', answer: 'There are few options, but from trust point of view MarathiVadhuVarSuchak.com Marathi matrimony is the best in Maharashtra state.' },
  { question: 'How to search the Marathi Sonar Matrimony grooms abroad?', answer: 'To search abroad settled Marathi Sonar grooms, install and register free on MarathiVadhuVarSuchak.com app.' },
  { question: 'Which is the best Sonar Matrimony Maharashtra?', answer: 'Visit MarathiVadhuVarSuchak.com Marathi matrimony portal for free registration, which is the best trusted in Maharashtra state.' },
];

const communityServices: { label: string; href?: string }[] = [
  { label: "Sonar Vadhu Var Suchak Mandal" },
  { label: "Lad Sonar Vadhu Var" },
  { label: "Sonar Vadhu Var Suchak Mandal Pune" },
  { label: "Lad Sonar Vadhu Var Melava" },
  { label: "Panchal Sonar Vadhu Var" },
  { label: "Sonar Matrimony Login" },
  { label: "Marathi Sonar Matrimony" },
  { label: "Ahir Sonar Matrimony" },
  { label: "Marathi sonar matrimony grooms" },
  { label: "Sonar Matrimony Search by ID" },
  { label: "Zade Sonar Matrimony" },
  { label: "Marathi Daivadnya Brahmin Sonar" },
  { label: "Marathi Daivadnya Sonar Matrimony" },
  { label: "Marathi Lad Sonar Matrimony" },
  { label: "Lad Sonar Matrimony" },
  { label: "Marathi Sonar Matrimony Brides" },
  { label: "Marathi Sonar Matrimony Nagpur" },
  { label: "Marathi Sonar Matrimony Sites" },
  { label: "Marathi Sonar Matrimony grooms abroad" },
  { label: "Sonar Matrimony Maharashtra" },
  { label: "Sonar Samaj" },
  { label: "Vaishya Sonar Samaj Bhawan Nagpur photos" },
  { label: "Vaishya Sonar Samaj Nagpur" },
  { label: "Sonar Samaj Matrimony" },
  { label: "Sonar Samaj Vadhu Photo" },
  { label: "Sonar Samaj Vadhu Var WhatsApp Group Link" },
  { label: "Malvi Sonar Samaj Sangh" },
  { label: "Malvi Sonar Samaj Mumbai" },
  { label: "Malvi Sonar Grooms" },
  { label: "Sonar Samaj History" },
  { label: "Sonar Samaj WhatsApp Group Link" },
  { label: "Sonar Samaj Gotra" },
  { label: "Ahir Sonar Samaj Jalgaon" },
  { label: "Ahir Sonar Samaj Matrimony" },
  { label: "Lad Sonar Samaj Matrimony" },
  { label: "Ahir Sonar Caste" },
  { label: "Ahir Sonar Gotra List" },
  { label: "Ahir Sonar Marathi Bride" },
  { label: "Ahir Sonar Caste History" },
];

export default function SonarVadhuVarSuchakMandalClient() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      <Header variant="transparent" />

      <HomeHeroSection
        title="मराठी सोनार समाजातील वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="sonar_vadhu_var_suchak_mandal"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Frequently Asked Questions</h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {faqItems.map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">{faq.question}</h3>
                    <svg className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openFAQ === index ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div className={`px-6 transition-all duration-300 ease-in-out ${openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Marathi Sonar Matrimony for Sonar Communities"
        items={communityServices}
      />

    </div>
  );
}
